import { PostLoginRestTriggerConfig } from "../components/restTriggers";

export const BLANK_HEADER = { destinationHeader: '', value: '', source: '' };
export const BLANK_PROXY_SETTINGS = {
    name: '',
    displayName: '',
    b2cPolicy: [],
    method: '',
    endpoint: '',
    headers: []
};
export interface HeaderData {
    destinationHeader: string;
    value: string;
    source: string;
}

export interface ProxySettingsData {
    name: string;
    b2cPolicy: string[];
    displayName: string;
    method: string;
    //Endpoint is base64 encoded
    endpoint: string;
    headers: HeaderData[];
    restTriggers: PostLoginRestTriggerConfig[];
}
